export const SET_TRAINING_ORDER = "SET_TRAINING_ORDER";
export const SET_CURRENT_TRAINING_ORDERS = "SET_CURRENT_TRAINING_ORDERS";
export const SET_OLD_TRAINING_ORDERS = "SET_OLD_TRAINING_ORDERS";
